import * as AuthHelper from '@Services/Auth/AuthHelper';
import get from 'lodash/get';
import AppStorage from '@Services/AppStorage';

export default class ExportReopenService {
  static KEY = 'reopenExport';

  static _REOPEN_STORAGE_KEY = 'lastExportFlag';

  static _DIALOG_STORAGE_KEY = 'dialog';

  static checkReopenExport() {
    const storageObj = AppStorage.instance.get(this.KEY) || {};
    return !AuthHelper.isAnonymousUser() && get(storageObj, this._REOPEN_STORAGE_KEY);
  }

  static saveReopenExport(value) {
    const storageObj = AppStorage.instance.get(this.KEY) || {};
    storageObj[this._REOPEN_STORAGE_KEY] = value;
    AppStorage.instance.set(this.KEY, storageObj);
  }

  static getStoredExportDialogStuff() {
    const storageObj = AppStorage.instance.get(this.KEY) || {};
    return get(storageObj, this._DIALOG_STORAGE_KEY);
  }

  static storeExportDialogStuff(dialogObj) {
    const storageObj = AppStorage.instance.get(this.KEY) || {};
    storageObj[this._DIALOG_STORAGE_KEY] = dialogObj;
    AppStorage.instance.set(this.KEY, storageObj);
  }
}
